<div [class.padding-top-large]="paddingTopLarge" class="content-wrap" layout-centered padding>
  <rt-feature-guard-content
    [featureData]="featureData"
    [availableFromPlan]="availableFromPlan"
    [canUpgrade]="canUpgrade"
    [customUpgradeButton]="customUpgradeButton"
    (openPlanPicker)="openPlanPicker()"
  >
  </rt-feature-guard-content>
</div>
